import React from "react";
import { icon } from "../../../common/components";
import { Flags } from "../../../common/providers";
import { DSIPlatform, DSIFormStudio, DSIAgents } from "../panels";
import DSIFeatures from "../panels/dsi-features/DSIFeatures";
import DSIData from "../panels/dsi-data/DSIData";

const TABS = [
	{
		tab: {
			icon: icon.faCog,
			title: "dsi.tab.title.platform-management",
			tooltip: "dsi.tab.tooltip.platform-management",
			param: "platform",
		},
		panel: () => <DSIPlatform />,
	},
	{
		tab: {
			icon: icon.faDatabase,
			title: "dsi.tab.title.data-management",
			tooltip: "dsi.tab.tooltip.data-management",
			param: "data",
		},
		panel: ({
			activeUsersInCompany,
			companies,
			createBu,
			createCompany,
			getCompanyActiveUsers,
			updateCompany,
			userRolesInCompany,
			userRolesInProject,
			changeBlockUser,
			createUser,
			regeneratePwdForUser,
			updateUserStatusInProject,
			companyRolesInProject,
			updateCompanyRoleInProject,
			addExistingPartnerToProject,
			addExistingUserToProject,
		}) => (
			<DSIData
				activeUsersInCompany={activeUsersInCompany}
				companies={companies}
				companyRolesInProject={companyRolesInProject}
				userRolesInCompany={userRolesInCompany}
				userRolesInProject={userRolesInProject}
				onAddExistingPartnerToProject={addExistingPartnerToProject}
				onAddExistingUserToProject={addExistingUserToProject}
				onChangeBlockUser={changeBlockUser}
				onCreateBu={createBu}
				onCreateCompany={createCompany}
				onCreateUser={createUser}
				onRegeneratePassword={regeneratePwdForUser}
				onSelectCompany={getCompanyActiveUsers}
				onUpdateCompany={updateCompany}
				onUpdateCompanyRoleInProject={updateCompanyRoleInProject}
				onUpdateUserStatusInProject={updateUserStatusInProject}
			/>
		),
	},
	{
		tab: {
			icon: icon.faFlag,
			title: "dsi.tab.title.features-management",
			tooltip: "dsi.tab.tooltip.features-management",
			param: "features",
		},
		panel: ({ companies }) => <DSIFeatures companies={companies} />,
	},
	{
		tab: {
			icon: icon.faTableList,
			title: "dsi.tab.title.criteria",
			tooltip: "dsi.tab.tooltip.criteria",
			param: "criteria",
		},
		panel: ({ companies }) => <DSIFormStudio platformCompanies={companies} />,
		flag: Flags.FORM_STUDIO,
	},
	{
		tab: {
			icon: icon.faRobot,
			title: "dsi.tab.title.agents",
			tooltip: "dsi.tab.tooltip.agents",
			param: "agent",
		},
		panel: () => <DSIAgents />,
	},
];
export default TABS;
